import React, { useState, useEffect } from 'react';
import { Tree, Button, Spin, Layout, message, Tabs, Statistic, Progress, Timeline, Space, Flex, Input, Row, Col, Breadcrumb, Tooltip } from 'antd';
import axios from 'axios';
import { SearchOutlined, ReloadOutlined, MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import Header166 from '../header/header';
import { cloneDeep } from 'lodash';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import './Poa.css';
import CountUp from 'react-countup';
import PoaObservaciones from './PoaObservaciones';
import ObservacionesTimeline from './ObservacionesTimeline';
import PoaActividades from './PoaActividades';
import { fetchPoaData, fetchPoaDataWithParams } from '../../services/poa/get_poa';



const { Content, Sider } = Layout;
const { TabPane } = Tabs;

const Poa = () => {
    const [treeData, setTreeData] = useState([]);
    const [dataCompleta, setDataCompleta] = useState([]); // Estado para la data completa
    const [selectedItem, setSelectedItem] = useState(null);

    const [loading, setLoading] = useState(true);
    const [expandAll, setExpandAll] = useState(false);
    const [showCards, setShowCards] = useState(false);
    const [collapsed, setCollapsed] = useState(false);

    const [expandedKeys, setExpandedKeys] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [autoExpandParent, setAutoExpandParent] = useState(true);
    const onExpand = (newExpandedKeys) => {
        setExpandedKeys(newExpandedKeys);
        setAutoExpandParent(true);
    };

    const [oidTarea, setOidTarea] = useState(selectedItem ? selectedItem.oid_tarea : null);

    const toggleTreeVisibility = () => {
        setCollapsed(!collapsed);
    };

    const handleOidTareaChange = (newOidTarea) => {
        setOidTarea(newOidTarea);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await fetchPoaData();
                // Filtrar los nodos hasta el tercer nivel
                const filteredData = data.map(item => {
                    // Filtrar los hijos de primer nivel (segundo nivel)
                    if (item.children && item.children.length > 0) {
                        item.children = item.children.map(child => {
                            // Filtrar los hijos de segundo nivel (tercer nivel)
                            if (child.children && child.children.length > 0) {
                                child.children = child.children.filter(grandchild => !grandchild.children);
                            }
                            return child;
                        });
                    }

                    return item;
                });

                setTreeData(filteredData);

                // Siempre expande el nodo raíz '0' al cargar los datos
                setExpandedKeys(keys => {
                    if (!keys.includes('0')) {
                        return [...keys, '0', 'producto_1'];
                    }
                    return [...keys, 'producto_1'];
                });


                if (!expandAll && data.length > 0) {
                    const initialKeysToExpand = data.slice(0, 9).map(item => item.key);
                    setExpandedKeys(initialKeysToExpand);
                }

            } catch (error) {
                console.error('Error fetching file tree:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [expandAll]);




    const onChange = (e) => {
        setSearchValue(e.target.value);
    };

    const clearHighlight = (nodes) => {
        nodes.forEach(node => {
            node.highlighted = false; // Establece todos los nodos como no destacados
            if (node.children) {
                clearHighlight(node.children); // Recursivamente limpia los hijos si existen
            }
        });
    };

    const getParentKey = (key, tree) => {
        let parentKey;
        for (let i = 0; i < tree.length; i++) {
            const node = tree[i];
            if (node.children) {
                if (node.children.some((item) => item.key === key)) {
                    parentKey = node.key;
                } else if (getParentKey(key, node.children)) {
                    parentKey = getParentKey(key, node.children);
                }
            }
        }
        return parentKey;
    };

    const toggleExpandAll = () => {
        setExpandAll(!expandAll); // Invierte el estado de expansión global

        if (!expandAll) {

            // Expandir todos los nodos


            const keysToExpand = getAllKeysToExpand(treeData, 2, 'Participantes');
            setExpandedKeys(keysToExpand);

        } else {

            // Contraer todos los nodos excepto el nodo '0'
            setExpandedKeys(['0']); // Asegura que el nodo '0' esté expandido explícitamente
        }
    };

    const getAllKeysToExpand = (data, level, excludedName) => {
        let keys = [];
        const traverse = (nodes, currentLevel) => {
            if (currentLevel > level) return;
            nodes.forEach(node => {
                if (node.name !== excludedName) {
                    keys.push(node.key);
                    if (node.children) {
                        traverse(node.children, currentLevel + 1);
                    }
                }
            });
        };
        traverse(data, 1);
        return keys;
    };

    const handleSelect = async (selectedKeys, info) => {
        const selectedNode = info.node;

        // Permitir la selección solo si el nodo es de tipo 'Producto'
        if (selectedNode.tipo === 'Producto') {
            try {
                // Realizar la solicitud al backend
                const data = await fetchPoaDataWithParams(selectedNode.key);
                // Verificar la respuesta
                if (data.status === 'success') {
                    const nodeFromDataCompleta = findNodeInData(data.dataPoa, selectedNode.key);

                    if (nodeFromDataCompleta) {
                        // Configurar selectedItem con el nodo encontrado en la respuesta
                        setSelectedItem(nodeFromDataCompleta);
                    }

                    setShowCards(false); // Mostrar las tarjetas si es necesario
                } else {
                    console.error('Error en la respuesta del backend:', data.message);
                    setSelectedItem(null);
                    setShowCards(false);
                }
            } catch (error) {
                console.error('Error en la solicitud al backend:', error);
                setSelectedItem(null);
                setShowCards(false);
            }
        } else {
            message.warning('Solo se pueden seleccionar elementos de tipo "Producto".');
        }
    };

    const findNodeInData = (data, key) => {
        for (let item of data) {
            if (item.key === key) {
                return item;
            } else if (item.children) {
                const found = findNodeInData(item.children, key);
                if (found) return found;
            }
        }
        return null;
    };


    const toggleShowCards = () => {
        setShowCards(!showCards);
    };


    const onLimpiarBusqueda = () => {
        setSearchValue('');
        setTreeData(cloneDeep(treeData));

        setExpandedKeys(['0']); // Establece explícitamente que el nodo '0' esté expandido
        toggleExpandAll(true); // Asegura que todos los nodos estén contraídos
        setSelectedItem(null); // Limpia el elemento seleccionado, si es necesario para tu lógica

    };

    const findNode = (nodes, key) => {
        for (const node of nodes) {
            pathToNode.push(node);
            if (node.key === key) {
                return true;
            }
            if (node.children && findNode(node.children, key)) {
                return true;
            }
            pathToNode.pop();
        }
        return false;
    };


    const titleRenderer = (node) => {
        const tooltipTitle = node?.producto || node?.actividad || node?.tarea || node?.indicador_meta || node?.title || 'Sin título';

        return (
            <Tooltip title={tooltipTitle} color='#87d068' placement="right">
                <span className={node.highlighted ? 'highlightedNode' : ''}>{node.title}</span>
            </Tooltip>
        );
    };


    // Define la función findPathToNode antes de usarla
    const findPathToNode = (treeData, key) => {
        const path = [];

        const findNode = (nodes, key) => {
            for (const node of nodes) {
                path.push(node);
                if (node.key === key) {
                    return true;
                }
                if (node.children && findNode(node.children, key)) {
                    return true;
                }
                path.pop();
            }
            return false;
        };

        findNode(treeData, key);
        return path;
    };

    const pathToNode = selectedItem ? findPathToNode(treeData, selectedItem.key) : [];

    const breadcrumbItems = pathToNode.map((node, index) => ({
        key: String(index),
        content: node.title,
    }));

    const TareaTimeline = ({ metas }) => {
        // Función para generar los items del Timeline
        const renderTimelineItems = (metaArray, labelPrefix) =>
            metaArray.map(meta => ({
                key: meta.oid,
                label: `${new Date(meta.fecha).toLocaleDateString()}`,
                children: meta.valor,
                color: labelPrefix === 'Proyectada' ? 'blue' : 'green' // Aquí se asigna el color dinámicamente
            }));

        return (
            <Row gutter={16}>
                <Col span={12}>
                    <h3>Meta Proyectada</h3>
                    <Timeline mode="right" items={renderTimelineItems(metas.meta_p, 'Proyectada')} />
                </Col>
                <Col span={12}>
                    <h3>Meta Ejecutada</h3>
                    <Timeline mode="right" items={renderTimelineItems(metas.meta_e, 'Ejecutada')} />
                </Col>
            </Row>
        );
    };

    const calcularSumaMetaE = (metaEjecutadaArray) => {
        return metaEjecutadaArray.reduce((total, meta) => total + meta.valor, 0);
    };

    const calcularPorcentajeAvance = (sumaMetaEjecutada, metaProyectada) => {
        if (metaProyectada === 0) {
            return 0; // Evitar división por cero
        }
        const porcentaje = (sumaMetaEjecutada / metaProyectada) * 100;
        return porcentaje.toFixed(2); // Redondear el porcentaje a 2 decimales
    };

    const calcularPromedioAvance = (indicadores) => {
        if (!indicadores.length) return 0;

        const sumaAvances = indicadores.reduce((total, indicador) => {
            const { metaEjecutada, metaProyectada } = indicador;
            const sumaMetaEjecutada = calcularSumaMetaE(metaEjecutada);
            const porcentajeAvance = calcularPorcentajeAvance(sumaMetaEjecutada, metaProyectada);
            return total + porcentajeAvance;
        }, 0);

        return sumaAvances / indicadores.length;
    };

    const AvanceIndicador = ({ metaEjecutada, metaProyectada }) => {
        const sumaMetaEjecutada = calcularSumaMetaE(metaEjecutada);
        const porcentajeAvance = calcularPorcentajeAvance(sumaMetaEjecutada, metaProyectada);
        const formatter = (value) => <CountUp end={value} separator="." decimals={2} />;

        const twoColors = {
            '0%': '#108ee9',
            '100%': '#87d068',
        };
        return (
            <div className="container"> {/* Clase container de Bootstrap para centrar el contenido */}
                <div className="row justify-content-center"> {/* Clase row de Bootstrap para una fila centrada */}
                    <div className="col-md-6">
                        <Tooltip title={`Ejecutada: ${sumaMetaEjecutada} / Meta: ${metaProyectada} = ${porcentajeAvance}%`}>
                            <Progress percent={porcentajeAvance} strokeColor={twoColors} strokeLinecap="round" />
                        </Tooltip>
                    </div>
                </div>
                <div className="row justify-content-center mt-3"> {/* Añade margen top (mt-3) para separación */}
                    <div className="col-md-3">
                        <Tooltip title={`Ejecutado: ${sumaMetaEjecutada} / Meta: ${metaProyectada} = ${porcentajeAvance}%`}>
                            <Progress
                                type="circle"
                                percent={porcentajeAvance}
                                strokeLinecap="round"
                                strokeColor={{
                                    '0%': '#108ee9',
                                    '100%': '#87d068',
                                }}
                            />
                        </Tooltip>
                    </div>
                </div>
                <div><Statistic title="Porcentaje de jecución:" value={porcentajeAvance} formatter={formatter} /></div>
            </div>
        );
    };

    const indicadores = [
        { metaEjecutada: [50, 30], metaProyectada: 100 },
        { metaEjecutada: [20, 40], metaProyectada: 100 },
        // Agrega más indicadores según sea necesario
    ];


    return (
        <Layout className="container">
            {loading ? (
                <div className="text-center">
                    <Spin size="large" />
                </div>
            ) : (
                <div className="container py-3">
                    <div className="row mb-2 d-flex align-items-center">
                        <Header166 type="poa" />
                        <div className="col-md-4 d-flex justify-content-center align-items-center flex-column">
                            <h2 className="text-center mb-2">UTF COL 166 COL</h2>
                        </div>
                    </div>
                    <div style={{ marginBottom: 8, textAlign: 'left' }}>
                        <h6 onClick={toggleTreeVisibility} style={{ cursor: 'pointer' }}>
                            POA: UTF COL 166 |
                            {collapsed ? <MenuUnfoldOutlined style={{ color: '#1677ff', paddingLeft: '5px' }} /> : <MenuFoldOutlined style={{ color: '#1677ff', paddingLeft: '5px' }} />}
                        </h6>
                    </div>
                    <Layout style={{ minHeight: '100vh' }}>
                        <Sider
                            width={230}
                            collapsedWidth={0}
                            className="site-layout-background"
                            collapsed={collapsed}
                            collapsible
                            trigger={null}
                            onCollapse={toggleTreeVisibility}
                            style={{ transition: 'all 0.3s' }}
                        >

                            {!collapsed && (
                                <Tree
                                    treeData={treeData}
                                    expandedKeys={expandedKeys}
                                    onExpand={onExpand}
                                    onSelect={handleSelect}
                                    autoExpandParent={autoExpandParent}
                                    titleRender={titleRenderer}
                                    showLine={true}
                                />
                            )}
                        </Sider>
                        <Layout style={{ padding: '0 24px 24px' }}>
                            <Content
                                className="site-layout-background"
                                style={{
                                    padding: 0,
                                    margin: 0,
                                    minHeight: 280,
                                }}
                            >
                                {selectedItem && (
                                    <Space direction="vertical" style={{ width: '100%' }} size="large">
                                        <Row gutter={0}>
                                            <Col span={24}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div style={{ marginRight: '10px' }}>
                                                        <Breadcrumb items={breadcrumbItems} />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row gutter={0} justify="center" align="middle">
                                            <Col span={24}>
                                                <div>
                                                    <h4 style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                        {selectedItem ?
                                                            (selectedItem.producto || selectedItem.actividad || selectedItem.tarea || selectedItem.indicador || selectedItem.title || 'Sin título')
                                                            : 'Sin elemento seleccionado'}

                                                        <button onClick={toggleShowCards} className="btn py-0 m-0" style={{ fontSize: '17px', color: '#8dc145' }}>
                                                            <FontAwesomeIcon icon={showCards ? faInfoCircle : faQuestionCircle} style={{ marginLeft: '5px' }} />
                                                        </button>
                                                    </h4>
                                                    <div className="d-flex justify-content-center">
                                                        {showCards && pathToNode.map((node, index) => (
                                                            node && (  // Verifica si node existe y no es null/undefined
                                                                <Card
                                                                    key={index}
                                                                    className={`m-2 ${showCards ? 'card-transition' : 'card-hidden'}`}
                                                                    style={{ width: '300px', overflowY: 'auto' }}
                                                                >
                                                                    <Card.Body>
                                                                        <Card.Title style={{ fontSize: '14px' }}>{node.producto || node.actividad || node.tarea || node.indicador || node.title || 'Sin título'}</Card.Title>
                                                                        {node.tipo === 'Fase' && <Card.Text>Fase: {node.title}</Card.Text>}
                                                                        {node.producto && <Card.Text>Producto: {node.codigo_producto}</Card.Text>}
                                                                        {node.actividad && <Card.Text>Código Actividad: {node.codigo_actividad}</Card.Text>}
                                                                        {node.tarea && <Card.Text>Código Tarea: {node.codigo_tarea}</Card.Text>}
                                                                        {node.tipo === 'Indicador' && <Card.Text>Código Indicador: {node.key}</Card.Text>}
                                                                    </Card.Body>
                                                                </Card>
                                                            )
                                                        ))}

                                                    </div>


                                                    <PoaActividades nodo={selectedItem} />

                                                </div>
                                            </Col>
                                        </Row>
                                    </Space>
                                )}


                            </Content>
                        </Layout>
                    </Layout>
                </div>
            )
            }
        </Layout >
    );
};

export default Poa;
